import { inject, Injectable } from '@angular/core';
import { ConfigOption, FormlyFieldConfig } from '@ngx-formly/core';
import { FormlyFieldConfigPresetProvider } from '@ngx-formly/core/lib/models';
import { DataSetupFacade } from '@portal/application/data-access';
import { map, take } from 'rxjs';
import { mapDataSetupSelectOptionToFormly } from '../util';
import { FormlySelectOption } from '@ngx-formly/core/select';

@Injectable()
export class AppointmentPresetProvider implements FormlyFieldConfigPresetProvider {
  private readonly dataSetupFacade = inject(DataSetupFacade);

  getConfiguration(): FormlyFieldConfig {
    let options: FormlySelectOption[] = [];

    this.dataSetupFacade.dataSetup$
      ?.pipe(
        map(dataSetup => mapDataSetupSelectOptionToFormly(dataSetup?.keyPersonnelAppointments)),
        take(1),
      )
      .subscribe(mappedOptions => {
        options = [{ label: 'You may select more than 1 option', group: [] }, ...mappedOptions];
      });

    return {
      type: 'mat-select',
      props: {
        label: 'Appointment/Designation',
        placeholder: 'Please Select',
        options: options,
      },
    };
  }
}

export function registerAppointmentPreset(): ConfigOption {
  return { presets: [{ name: 'appointment', config: new AppointmentPresetProvider() }] };
}
